import { AppHomeComponent, MultiAccountComponent, RegistrationComponent, SecurityComponent } from 'security';
import { HierarchyManagementComponent, SvmHierComponent } from 'svm-hier';
import { ListComponent, RrvComponent } from 'svm-crudui';
import { RouterModule, Routes } from '@angular/router';

import { AllappsComponent } from './allapps/allapps.component';
import { BusinessTermComponent } from './business-term/business-term.component';
import { ClassificationComponent } from './classification/classification.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { HierComponent } from './hier/hier.component';
import { HomeComponent } from './home/home.component';
import { NewDataEngComponent } from './new-data-eng/new-data-eng.component';
import { NgModule } from '@angular/core';
import { PhyFileComponent } from './phy-file/phy-file.component';

const routes: Routes = [
  { path: '', redirectTo: 'all-apps', pathMatch: 'full' },
  { path: 'login', component: SecurityComponent },
  { path: 'multi-account', component: MultiAccountComponent },
 // { path: 'register', component: RegistrationComponent },
 {
    path: '', component: HomeComponent, children: [
      {
        path: '', component: HomeComponent,
      },
      {
        path: 'dash', component: DashboardComponent,
      },
     
      { path: 'dashboard', component: DashboardComponent },
      { path: 'all-apps', component: AllappsComponent },
      { path: 'rrv', component: RrvComponent },
      { path: 'list', component: ListComponent },
      { path: 'data-eng', component: NewDataEngComponent },
      { path: 'data-discovery', component: AllappsComponent },
      { path: 'term', component: BusinessTermComponent },
      { path: 'pf', component: PhyFileComponent },
      { path: 'cl', component: ClassificationComponent },
      { path: 'hier', component: HierComponent },
      { path: 'hr-manage', component: HierarchyManagementComponent },

    
      


    ]
  },




];

@NgModule({
  imports: [RouterModule.forRoot(routes, { useHash: true })],
  exports: [RouterModule],
})
export class AppRoutingModule { }
